(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["list-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".load-more-wrapper").forEach(section => {

    const sectionId = section.dataset.sectionId;
    const btn = section.querySelector(".load-more-btn");
    const wrapper = section.querySelector("#products-wrapper-" + sectionId);

    if (!btn || !wrapper) return;

    btn.addEventListener("click", () => {
      btn.disabled = true;
      btn.textContent = btn.dataset.loadingText;

      fetch(btn.dataset.next)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newItems = doc.querySelectorAll(`#products-wrapper-${sectionId}`);
          newItems.forEach(item => wrapper.appendChild(item));

          let lazyEvent = new CustomEvent('sn:lazyReload');
          document.dispatchEvent(lazyEvent);

          const newNext = doc
            .querySelector(`.load-more-wrapper[data-section-id='${sectionId}'] .load-more-btn`)
            ?.getAttribute("data-next");

          if (newNext) {
            btn.dataset.next = newNext;
            btn.disabled = false;
            btn.textContent = btn.dataset.text;
          } else {
            btn.remove();
          }
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
